import { getRetailerTypes as getStoreLocatorTypes } from "components/store-locator/components/StoreLocator/MainStoreLocator/List/utils"

export const getRetailerTypeText = ({ retailer, dealerData, dictionary, isLowercase }) => {
  const { rolexIsFlagship, type, isAffiliate } = retailer
  if (rolexIsFlagship) return isLowercase ? dictionary.officialBoutiqueLowercase() : dictionary.officialBoutique()
  if (type === "SERVICECENTER" && isAffiliate) return ""

  const types = getStoreLocatorTypes({ retailer, dealerData })
  const isRetailer = types.includes("retailer")
  const isServiceCenter = types.includes("servicecenter")

  if (isServiceCenter && isRetailer) {
    return dictionary.seoOfficialRetailerServiceCentre()
  }

  return isLowercase ? dictionary.officialRetailerLowercase() : dictionary.officialRetailer()
}

export const FeedRetailerData = ({ retailer, text, retailerType, isDealer }) => {
  const { nameTranslated, cityName, countryName, name } = retailer
  const updatedText = text
    .replace("{{cityName}}", cityName)
    .replace("{{countryName}}", countryName)
    .replace("{{retailerType}}", retailerType)
    .replaceAll("{{retailerName}}", isDealer ? name : nameTranslated)
  return updatedText
}

export const getRetailerTypes = ({ retailer }) => {
  const { type, isHiddenRCPO, brand, rolexIsFlagship } = retailer
  const typeList = []

  if (rolexIsFlagship) typeList.push("boutique")

  typeList.push("servicing")

  if (brand.includes("RCPO") && !isHiddenRCPO) typeList.push("rcpo")

  if (brand.includes("RLX")) typeList.push("buying")

  return typeList
}

export const updateLinkWithEstablishment = (link, establishment, dealer, isDealer = false) => {
  const linkUpdated = isDealer
    ? link.href.replace(/:dealer\?/, `${establishment?.urlRolexV7 || dealer?.urlRolexV7 || ""}`)
    : link.href.replace(/:dealer\?\/:establishment\?/, `${establishment?.urlRolexV7 || dealer?.urlRolexV7 || ""}`)
  //console.log("linkUpdated: ", linkUpdated)
  link.href = linkUpdated
  return link
}
